import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/Semitrailers';
import { useAuthValidation } from '../../utils/hooks';

const TrucksPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default TrucksPage;
